
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireea93"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireea93"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $88cece5baea9bf00$exports = {};
$parcel$extendImportMap({
    "da4Ek": "service-worker.js"
});

var $77197f19fc13d742$exports = {};
$77197f19fc13d742$exports = $parcel$resolve("da4Ek");


navigator.serviceWorker.register($77197f19fc13d742$exports)////const sw = "js/service-worker.js"; // it is needed because parcel will not recognize this as a file and not precess in its manner
//navigator.serviceWorker
//.register(sw, {type:'module'})
.then((registration)=>{
    registration.onupdatefound = ()=>{
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = ()=>{
            if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                else console.log("Content is cached for offline use.");
            }
        };
    };
}).catch((error)=>{
    console.error("Error during service worker registration:", error);
});


//# sourceMappingURL=xeroconv-dev.b1013645.js.map
